import React from 'react'

import { Subsection } from '@fourthwall/components'
import { useFormikContext } from '@fourthwall/utils/dist/formik'

import { PostTypeButtons } from '../../components/PostTypeButtons'
import type { FormValues } from '../../types'
import { FormFields } from '../../types'
import { TYPE_BUTTONS } from './const'

type Props = {
  disabled?: boolean
}

export const PostTypeFields = ({ disabled }: Props) => {
  const { values, setFieldValue } = useFormikContext<FormValues>()

  return (
    <Subsection>
      <PostTypeButtons
        buttons={TYPE_BUTTONS}
        activeButton={values.postType}
        disabled={disabled}
        onClick={(type) => {
          setFieldValue(`${FormFields.postType}`, type)
        }}
      />
    </Subsection>
  )
}
